<template>
  <!-- 仪表档案 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
    >
      <template slot="menuLeft">
        <el-button
          v-if="permission.meter_management_add"
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="openDialog('add')"
        >
          新增
        </el-button>
        <el-button
          v-if="permission.meter_management_import"
          type="success"
          plain
          size="small"
          icon="el-icon-upload2"
          @click="openDialog('import')"
        >
          导入
        </el-button>
      </template>
      <template slot-scope="{ row }" slot="menu">
        <el-button
          type="text"
          size="small"
          v-if="permission.meter_management_view"
          @click="openDialog('view', row)"
        >
          查看
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if="permission.meter_management_edit"
          @click="openDialog('edit', row)"
        >
          编辑
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if="permission.meter_management_del"
          @click="doDel(row.id)"
        >
          删除
        </el-button>
        <el-button
          type="text"
          size="small"
          v-if="permission.meter_management_add && row.meterCategory == 'EXPEND_METER'"
          @click="openDialog('addChild', row)"
        >
          新增子项
        </el-button>
      </template>
      <template slot="alarmFlag" slot-scope="{ row }">
        <el-tag type="danger" v-if="row.alarmFlagName == '是'">{{ row.alarmFlagName }}</el-tag>
        <span v-else>{{ row.alarmFlagName || '' }}</span>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      :title="dialogTitle"
      :width="dialogType == 'import' ? '400px' : '60%'"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <ImportFile
        v-if="isDialogShow && dialogType == 'import'"
        title=""
        :withApiTips="true"
        exportApi="/api/shunt/meter/exportTemplate"
        importApi="/api/shunt/meter/importShuntMeter"
        @uploadCallBack="importCallBack"
      ></ImportFile>
      <Form
        v-else-if="isDialogShow && dialogType != ''"
        :dialogType="dialogType"
        :areaCode="searchForm.areaCode"
        :rowData="rowData"
        @update="updateTableDataSuccess"
        @close="beforeCloseDialog"
      ></Form>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { getAreaList } from '@/api/meter-management/meter-permission';
import { getDict, getPageList, remove } from '@/api/meter-management/index';

export default {
  components: {
    ImportFile: () => import('@/views/nursingHome/initData/importFile'),
    Form: () => import('./components/meter-form'),
  },
  data() {
    return {
      isPageCache: false, // 当前页面是否从后台直接显示的 true-从后台直接显示的，也就是页面是缓存状态 false-重新加载的
      areaCodes: [], // 区域列表
      searchForm: {}, // 搜索条件
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      rowData: [], // 选中行对应的数据
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        defaultExpandAll: true,
        rowKey: 'id',
        dialogClickModal: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menuWidth: 200,
        searchMenuSpan: 6,
        searchLabelWidth: 100,
        column: [
          {
            label: '仪表表号',
            prop: 'code',
            search: true,
            maxlength: 30,
            showWordLimit: true,
            minWidth: 150,
          },
          {
            label: '仪表名称',
            prop: 'name',
            search: true,
            maxlength: 30,
            showWordLimit: true,
            minWidth: 150,
            overHidden: true,
          },
          {
            label: '管理区域',
            prop: 'areaCode',
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            type: 'tree',
            search: true,
            searchClearable: false,
            searchOrder: 2,
          },
          {
            label: '期初起码',
            prop: 'initStartNum',
          },
          {
            label: '仪表类型',
            prop: 'meterType',
            width: 80,
            type: 'select',
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            search: true,
          },
          {
            label: '仪表类别',
            prop: 'meterCategory',
            width: 80,
            type: 'select',
            dicData: [],
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            search: true,
          },
          {
            label: '上级仪表',
            prop: 'parentName',
            minWidth: 150,
            overHidden: true,
          },
          {
            label: '是否预充值表',
            prop: 'prepayFlag',
            width: 100,
            type: 'select',
            dicData: [
              { label: '是', value: 'YES' },
              { label: '否', value: 'NO' },
            ],
            search: true,
          },
          {
            label: '预充值表余额',
            prop: 'balance',
          },
          {
            label: '余额预警',
            prop: 'alarmFlag',
            width: 80,
            type: 'select',
            dicData: [
              { label: '是', value: 'YES' },
              { label: '否', value: 'NO' },
            ],
            search: true,
            slot: true,
          },
          {
            label: '仪表型号',
            prop: 'meterModel',
          },
          {
            label: '仪表品牌',
            prop: 'meterBrand',
          },
          {
            label: '安装日期',
            prop: 'installDate',
            width: 90,
          },
          {
            label: '安装位置',
            prop: 'installAddr',
            overHidden: true,
          },
          {
            label: '表倍率',
            prop: 'multiplier',
          },
          {
            label: '备注',
            prop: 'description',
            overHidden: true,
          },
          {
            label: '计量范围',
            prop: 'measureRange',
            overHidden: true,
          },
          {
            label: '辅助字段',
            prop: 'auxField',
            overHidden: true,
          },
          {
            label: '操作人',
            prop: 'operatorName',
          },
          {
            label: '操作时间',
            prop: 'operateTime',
            width: 130,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
  },
  created() {
    getDict({ code: 'shunt_meter_type' }).then(({ data }) => {
      this.findObject(this.tableOption.column, 'meterType').dicData = data;
    });
    getDict({ code: 'shunt_meter_category' }).then(({ data }) => {
      this.findObject(this.tableOption.column, 'meterCategory').dicData = data;
    });
    this.initData();
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 从缓存状态恢复窗口显示时重新请求下数据
    if (this.isPageCache) {
      this.initData();
    }
    this.isPageCache = true;
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    initData() {
      getAreaList().then(({ data }) => {
        this.areaCodes = data || [];
        if (this.areaCodes.length > 0) {
          this.findObject(this.tableOption.column, 'areaCode').dicData = this.areaCodes;
          this.searchForm.areaCode = this.areaCodes[0].dictKey;
          this.loadData();
        }
      });
    },
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 390; // 表格区域初始化高度
      const searchH = 112; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.areaCode) return;
      page = page || this.tablePage;
      this.loading = true;
      getPageList(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.searchForm)
      )
        .then(({ data }) => {
          this.tablePage.total = data.total;
          this.tableData = data.records;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        areaCode: this.areaCodes[0].dictKey,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 表格数据更新成功 */
    updateTableDataSuccess() {
      this.loadData();
      this.dialogType = '';
      this.isDialogShow = false;
    },
    /* 删除数据 */
    doDel(id) {
      this.$confirm('确定将选择数据删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({
            id,
          });
        })
        .then(() => {
          this.updateTableDataSuccess();
          this.$message.success('操作成功!');
        });
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        view: '查看',
        add: '新增',
        addChild: '新增子项',
        edit: '编辑',
        import: '导入',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      if (type == 'view') {
        this.needCloseConfirm = false;
      } else {
        this.needCloseConfirm = true;
      }
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
    /* 导入成功的回调 */
    importCallBack(ret) {
      if (ret) {
        this.dialogType = '';
        this.isDialogShow = false;
        this.tablePage.currentPage = 1;
        this.tablePage.total = 0;
        this.tableData = [];
        this.loadData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 搜索区域表单的每一项宽度最大化 */
::v-deep .avue-crud__search .el-form-item {
  width: 100%;
}
</style>
